import * as React from 'react';

import {LeadTwoLine} from '../lead/lead-two-line';

type Props = {
    leadName: string;
    leadStatus: string;
    leadNumber: number | null | undefined;
    priority?: string;
    htmlUrl: string;
    avatarUrl: string;
    primaryContact:
        | {
              id: string;
              type: string;
              htmlUrl: string;
              name: string;
          }
        | null
        | undefined;
};

export function LeadCell(props: Props) {
    const {primaryContact, ...restProps} = props;

    return <LeadTwoLine {...restProps} relatedPerson={primaryContact} />;
}
